// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","691":"component---src-pages-index-tsx","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"c873acf865e99d00cfe6","691":"7d762638e54eb04895d8","883":"d64a067c8174c5fa2834"}[chunkId] + ".js";
};